// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"944816b8","61":"842d0e68","333":"3c995049"}[chunkId] + ".chunk.css";
};